import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import { Link } from 'react-router-dom';

const RefundPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h3" gutterBottom>
          Refund Policy
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          Last updated: {new Date().toLocaleDateString()}
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            Digital Products and Services
          </Typography>
          <Typography variant="body1" paragraph>
            Due to the digital nature of our services, all sales of energy credits and subscription plans are final and non-refundable. Once credits are purchased and added to your account, they cannot be refunded or exchanged for cash.
          </Typography>

          <Typography variant="h5" gutterBottom>
            Exceptional Circumstances
          </Typography>
          <Typography variant="body1" paragraph>
            In exceptional circumstances, such as:
          </Typography>
          <ul>
            <li>Duplicate transactions</li>
            <li>Unauthorized purchases</li>
            <li>Technical errors resulting in incorrect charges</li>
          </ul>
          <Typography variant="body1" paragraph>
            Please contact us within 7 days of the transaction at service@eevolve.ai with your transaction details. We will review each case individually and may issue refunds at our discretion.
          </Typography>

          <Typography variant="h5" gutterBottom>
            How to Request a Refund
          </Typography>
          <Typography variant="body1" paragraph>
            To request a refund, please contact our support team at service@eevolve.ai with:
          </Typography>
          <ul>
            <li>Your account email address</li>
            <li>Date of purchase</li>
            <li>Transaction ID</li>
            <li>Reason for refund request</li>
          </ul>

          <Typography variant="h5" gutterBottom>
            Processing Time
          </Typography>
          <Typography variant="body1" paragraph>
            Approved refunds will be processed within 7-10 business days and will be credited to the original payment method.
          </Typography>

          <Typography variant="h5" gutterBottom>
            Contact Information
          </Typography>
          <Typography variant="body1" paragraph>
            For any questions about our refund policy, please contact us at service@eevolve.ai.
          </Typography>

          <Box sx={{ mt: 4, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
            <Typography variant="body2" color="text.secondary">
              By making a purchase on eEvolve.ai, you acknowledge that you have read, understood, and agree to this refund policy.
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default RefundPolicy;